<template>
  <div class="article-body-text">
    <div v-html="item.content.html" ref="body-html"></div>
  </div>
</template>

<script>
  export default {
    name: 'amp-text',
    props: ['item'],
  }
</script>

<style lang="scss">
  @import 'assets/scss/typography';

  .article-body-text {
    display: inline-block;
    font-size: rem-calc(18);
    color: $amp-dark-jungle-green;
    line-height: rem-calc(28);
    font-family: $roboto;
    padding-left: rem-calc(20);
    padding-right: rem-calc(20);

    p {
      -webkit-margin-before: 0;
      -webkit-margin-after: 0;
      margin-bottom: rem-calc(28);
    }

    a {
      color: $amp-dark-jungle-green;
      text-decoration: underline $amp-text-underline;
    }

    h3 {
      -webkit-margin-before: 0;
      -webkit-margin-after: 0;
      font-family: $barlow;
      color: $rose;
      margin-bottom: rem-calc(12);
    }
  }
</style>




// WEBPACK FOOTER //
// AmpText.vue?4700af4e